var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-to-top",class:{ visible: _vm.isVisible },on:{"click":_vm.scrollToTop}},[_c('van-icon',{attrs:{"name":"back-top","size":"24"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }